import { BASE_URL, SEND_TO_PROCESSOR } from '../../constants/apiUrls/apiUrls';
import { PROMO_CODES } from '../../constants/promoCodes';
import callApi from '../../utils/callApi';


export const DEFAULT_POST_PARAMS = {
  originalDomain: BASE_URL || new URL(document.URL).origin,
  paymentType: 'CC',
  returnPath: '/checkout',
};

export const getPurchaseError = (reason) => {
  switch (reason) {
    case 'ALREADY_HAS_MEMBERSHIP':
      return 'You already have active membership';
    case 'LOGIN_REQUIRED':
      return 'Your session timed out. Please log in again';
    default:
      return 'Something went wrong, please try again later';
  }
};

const PARALLEL_DOMAINS = ['nakednewslive.com', 'nudenews.com', 'nakednews-qa.staging.smart-x.dev'];

const isParallelDomain = (value) => PARALLEL_DOMAINS.some((domain) => value.includes(domain));

export const generateSiteSubcat = (originalDomain, anchorShortUrl) => {
  let domainName = originalDomain;

  if (isParallelDomain(domainName)) {
    domainName = 'https://www.nakednews.com';
  }

  let url = `${domainName}/${anchorShortUrl}`;
  url = new URL(url);
  url.search = '';

  return url.
    toString().
    replace(/(^\w+:|^)\/\//, '').
    replace('www.', '');
};

export const redirectToProcessor = (url, params, closeTipping, closeModal) => {
  let buildUrl = `${url}?`;
  let parsedKey = '';

  if (params) {
    for (const key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) {
        continue;
      }
      parsedKey =
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}&`;
      buildUrl += parsedKey;
    }
  }
  window.location.href = buildUrl;
  if (closeTipping) {
    closeTipping();
  } else if (closeModal) {
    closeModal();
  }
};

export const getPaymentProcessor = (processorId, priceId, username, processorData, extraPayload) => {
  const url = SEND_TO_PROCESSOR.replace(
    '{username}',
    encodeURIComponent(username)
  ).
    replace('{processorId}', encodeURIComponent(processorId)).
    replace('{priceId}', encodeURIComponent(priceId));

  return callApi(
    url,
    'post',
    {},
    JSON.stringify({
      ...processorData,
      ...extraPayload
    }),
    { 'content-type': 'application/json; charset=utf-8' },
    false,
    false
  );
};

export const decidePromoInfo = (
  promoPage,
  activeCampaign,
  promoBlockedByAtc,
  promoCodeInfo,
  anchorPortalCampaign,
  NNLivePromoPage,
  NNPromoPage,
  fanDiscountActive,
  hasAtc,
  hasPromoInURL,
  data,
  email,
) => {
  const processorData = data;
  // use passThrough to send params to Payment that need to be sent back to NN
  processorData.passThrough = {};
  if (hasPromoInURL?.affiliateCode) {
    processorData.passThrough.affiliateCode = hasPromoInURL?.affiliateCode;
  }

  if (hasPromoInURL?.hash) {
    processorData.passThrough.hash = hasPromoInURL?.hash;
  }

  if (promoPage && activeCampaign.name && !promoBlockedByAtc) {
    processorData.passThrough.affiliateCode = activeCampaign.affiliateCode;
  } else if (promoPage && activeCampaign.name && promoBlockedByAtc) {
    processorData.passThrough.affiliateCode = hasAtc;
  }
  if (promoCodeInfo.affiliateCode) {
    processorData.passThrough.affiliateCode = promoCodeInfo.affiliateCode;
  }
  if (NNLivePromoPage) {
    processorData.passThrough.affiliateCode = 'nnlpromo20220505';
  }
  if (NNPromoPage) {
    processorData.passThrough.affiliateCode = 'nnpromo20220505';
  }
  if (hasAtc) {
    processorData.passThrough.affiliateCode = hasAtc;
  }

  processorData.affiliateCode = processorData?.passThrough?.affiliateCode;
  processorData.pcode = activeCampaign?.affiliateCode;
  if (activeCampaign?.affiliateCode) {
    processorData.passThrough = { ...processorData?.passThrough, campaignAffiliateCode: activeCampaign?.affiliateCode };
  }

  if (Object.keys(processorData.passThrough).length < 1) {
    delete processorData.passThrough;
  }




  if (email) {
    processorData.email = email;
  }

  return processorData;
};

export const addDataForGiftAndItemProduct = (data, anchorShortUrl) => {
  const dataForProcessor = data;
  if (
    !dataForProcessor.siteSubcat &&
    (dataForProcessor.productType === 'GIFT' ||
      dataForProcessor.productType === 'ITEM')
  ) {
    if (anchorShortUrl) {
      dataForProcessor.siteSubcat = generateSiteSubcat(
        dataForProcessor.originalDomain,
        anchorShortUrl
      );
    }
  }

  return dataForProcessor;
};

export const formatRecurringPeriodString = (period, type) => {
  const year = 12;
  const week = 7;

  if (period === year && type === 'month') {
    return 'annually';
  }
  if (period === week && type === 'day') {
    return 'weekly';
  }

  return `${type}ly`;
};
